import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { TouchableOpacity, Text } from "react-native";
import { setLang } from "../../redux/reducers";
import { BRAND_COLORS, TEXT_COLORS } from "../../style/colors.js";

const LanguageToggleButton = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.lang.value); // Verificar el acceso al estado global

  const toggleLanguage = () => {
    const newLang = lang === "en" ? "es" : "en";
    dispatch(setLang(newLang));
  };

  return (
    <TouchableOpacity
      style={{
        marginRight: 5,
        padding: 7,
        backgroundColor: `${BRAND_COLORS.PRIMARY}80`,
        borderRadius: 5,
      }}
      onPress={toggleLanguage}>
      <Text style={{ color: TEXT_COLORS.LIGHT, fontWeight: "bold" }}>
        {lang === "en" ? "EN" : "ES"}
      </Text>
    </TouchableOpacity>
  );
};

export default LanguageToggleButton;
